// extracted by mini-css-extract-plugin
export var content = "TertiaryCard-module--content--204a9";
export var contentContainer = "TertiaryCard-module--contentContainer--c7876";
export var contentContainerText = "TertiaryCard-module--contentContainerText--6b3b5";
export var heading = "TertiaryCard-module--heading--fd601";
export var image = "TertiaryCard-module--image--95377";
export var list = "TertiaryCard-module--list--837a3";
export var listContainer = "TertiaryCard-module--listContainer--65a69";
export var subheading = "TertiaryCard-module--subheading--92c66";